import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "col-lg-6 d-flex flex-column justify-content-end" }
const _hoisted_6 = { class: "mt-5" }
const _hoisted_7 = { class: "table table-bordered table-hover" }
const _hoisted_8 = { class: "table-secondary" }
const _hoisted_9 = { class: "align-middle text-center" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "align-middle text-center" }
const _hoisted_12 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_13 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_14 = {
  style: {"width":"120px"},
  class: "text-center align-middle"
}
const _hoisted_15 = { class: "dropdown d-inline mr-1" }
const _hoisted_16 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "dropdown-item" }
const _hoisted_19 = ["onClick", "disabled"]
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-muted" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-muted" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "text-muted" }
const _hoisted_30 = { class: "text-center align-middle" }
const _hoisted_31 = { class: "text-center align-middle" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "mt-5" }
const _hoisted_40 = { class: "table table-bordered table-hover" }
const _hoisted_41 = { class: "table-secondary" }
const _hoisted_42 = { class: "align-middle text-center" }
const _hoisted_43 = { class: "align-middle text-center" }
const _hoisted_44 = { class: "totalCost" }
const _hoisted_45 = {
  class: "align-middle text-center",
  style: {"width":"60px"}
}
const _hoisted_46 = { class: "text-muted" }
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = { class: "text-center" }
const _hoisted_49 = { class: "text-center" }
const _hoisted_50 = { class: "text-center" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "opex" }
const _hoisted_54 = {
  class: "align-middle text-center",
  style: {"width":"60px"}
}
const _hoisted_55 = { class: "text-center" }
const _hoisted_56 = { class: "text-center" }
const _hoisted_57 = { class: "text-center" }
const _hoisted_58 = { class: "text-center" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "capex" }
const _hoisted_62 = {
  class: "align-middle text-center",
  style: {"width":"60px"}
}
const _hoisted_63 = { class: "text-center" }
const _hoisted_64 = { class: "text-center" }
const _hoisted_65 = { class: "text-center" }
const _hoisted_66 = { class: "text-center" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "othex" }
const _hoisted_70 = {
  class: "align-middle text-center",
  style: {"width":"60px"}
}
const _hoisted_71 = { class: "text-center" }
const _hoisted_72 = { class: "text-center" }
const _hoisted_73 = { class: "text-center" }
const _hoisted_74 = { class: "text-center" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "expenses" }
const _hoisted_78 = {
  class: "align-middle text-center",
  style: {"width":"60px"}
}
const _hoisted_79 = { class: "text-center" }
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = { class: "text-center" }
const _hoisted_82 = { class: "text-center" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = ["onClick"]
const _hoisted_85 = { class: "opex-expenses" }
const _hoisted_86 = {
  class: "align-middle text-center",
  style: {"width":"60px"}
}
const _hoisted_87 = { class: "text-center" }
const _hoisted_88 = { class: "text-center" }
const _hoisted_89 = { class: "text-center" }
const _hoisted_90 = { class: "text-center" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "mt-5" }
const _hoisted_94 = { class: "table table-bordered table-hover" }
const _hoisted_95 = {
  class: "align-middle text-center",
  style: {"width":"60px"}
}
const _hoisted_96 = ["onClick"]
const _hoisted_97 = { class: "text-center" }
const _hoisted_98 = { class: "text-center" }
const _hoisted_99 = { class: "text-center" }
const _hoisted_100 = { class: "text-muted" }
const _hoisted_101 = { class: "text-center" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { class: "text-center" }
const _hoisted_105 = { class: "text-center" }
const _hoisted_106 = { class: "text-muted" }
const _hoisted_107 = { class: "mt-5" }
const _hoisted_108 = { class: "table table-bordered table-hover" }
const _hoisted_109 = { class: "text-primary" }
const _hoisted_110 = { class: "align-middle text-center" }

import { computed, onMounted, shallowReactive, watch, type Ref, ref } from 'vue'
    import { useRoute } from 'vue-router'

    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'
    import ScenarioNavigation from '@Quest/CorporateScenarios/Components/ScenarioNavigation.vue'
    import SelectorDialog from '@Quest/PortfolioScenarios/Components/SelectorDialog.vue'
    import NumericInputDialog from '@common/Components/NumericInputDialog.vue'

    import { NumericInputDialogViewModel } from '@common/Components/NumericInputDialog'
    import { SelectorDialogViewModel } from '@Quest/PortfolioScenarios/Components/SelectorDialog'

    import
    {
        calculateProportionOf,
        parseOptionalNumber,
        sumOrDefault,
        toPercentageString,
        toStringSmartly
    } from '@common/Common'

    import type {
        BudgetAllocationSummaryReadModel,
        PortfolioBudgetAllocationReadModel,
        PortfolioResourceAllocationReadModel,
        PortfoliosPageReadModel,
        PortfolioSummaryReadModel,
        ResourceAllocationSummaryReadModel
    } from '@Quest/CorporateScenarios/readmodels'

    // ======================
    // Route
    // ======================

    import { usePortfoliosPageQueryV1 } from '@Quest/CorporateScenarios/queries-vue-composables'

    import
        {
            useSetPortfolioResourceAllocationCommandV1,
            useUpdateActivePortfolioScenarioCommandV1,
            useSetPortfolioTotalCostLimitCommandV1,
            useSetPortfolioCapexLimitCommandV1,
            useSetPortfolioOpexLimitCommandV1,
            useSetPortfolioOthexLimitCommandV1,
            useSetPortfolioExpensesLimitCommandV1,
            useSetPortfolioOpexExpensesLimitCommandV1
        } from '@Quest/CorporateScenarios/commands-vue-composables'

    import { SetPortfolioResourceAllocationCommandV1 } from '../commands-core'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PortfoliosPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))
    const scenarioId = computed(() => String(route.params.scenarioId ?? ''))

    // ======================
    // Query
    // ======================

    const {
        runPortfoliosPageQueryV1,
        modelPortfoliosPageQueryV1
    } = usePortfoliosPageQueryV1(workspaceId, strategyId, scenarioId)

    const rm = modelPortfoliosPageQueryV1 as Ref<PortfoliosPageReadModel | null>

    // ======================
    // Commands
    // ======================

    const {
        invokeSetPortfolioResourceAllocationCommandV1,
        onSucceedSetPortfolioResourceAllocationCommandV1,
        command: setPortfolioResourceAllocationCommand
    } = useSetPortfolioResourceAllocationCommandV1(workspaceId, strategyId, scenarioId)

    const {
        invokeUpdateActivePortfolioScenarioCommandV1,
        onSucceedUpdateActivePortfolioScenarioCommandV1
    } = useUpdateActivePortfolioScenarioCommandV1(workspaceId, strategyId, scenarioId)

    const { invokeSetPortfolioTotalCostLimitCommandV1 } =
        useSetPortfolioTotalCostLimitCommandV1(workspaceId, strategyId, scenarioId)

    const { invokeSetPortfolioCapexLimitCommandV1 } =
        useSetPortfolioCapexLimitCommandV1(workspaceId, strategyId, scenarioId)

    const { invokeSetPortfolioOpexLimitCommandV1 } =
        useSetPortfolioOpexLimitCommandV1(workspaceId, strategyId, scenarioId)

    const { invokeSetPortfolioOthexLimitCommandV1 } =
        useSetPortfolioOthexLimitCommandV1(workspaceId, strategyId, scenarioId)

    const { invokeSetPortfolioExpensesLimitCommandV1 } =
        useSetPortfolioExpensesLimitCommandV1(workspaceId, strategyId, scenarioId)

    const { invokeSetPortfolioOpexExpensesLimitCommandV1 } =
        useSetPortfolioOpexExpensesLimitCommandV1(workspaceId, strategyId, scenarioId)

    // ======================
    // ViewModels + state (1:1)
    // ======================

    const selectorDialog = shallowReactive(new SelectorDialogViewModel())

    const totalCostLimitEditorDialog = shallowReactive(new NumericInputDialogViewModel())
    const opexLimitEditorDialog = shallowReactive(new NumericInputDialogViewModel())
    const othexLimitEditorDialog = shallowReactive(new NumericInputDialogViewModel())
    const capexLimitEditorDialog = shallowReactive(new NumericInputDialogViewModel())
    const expensesLimitEditorDialog = shallowReactive(new NumericInputDialogViewModel())
    const opexExpensesLimitEditorDialog = shallowReactive(new NumericInputDialogViewModel())
    const portfolioResourceAllocationEditorDialog = shallowReactive(new NumericInputDialogViewModel())

    const budget = ref<BudgetAllocationSummaryViewModel | null>(null)
    const resources = ref<ResourceAllocationSummaryViewModel[]>([])

    // replace onSetModel
    watch(rm, (current) =>
    {
        if (!current) return

        resources.value = current.Resources.map(r => new ResourceAllocationSummaryViewModel(r))
        budget.value = new BudgetAllocationSummaryViewModel(current.Budget)
    })

    onSucceedUpdateActivePortfolioScenarioCommandV1(() =>
    {
        window.location.reload()
    })

    onSucceedSetPortfolioResourceAllocationCommandV1(() =>
    {
        const cmd1 = setPortfolioResourceAllocationCommand.value as SetPortfolioResourceAllocationCommandV1

        const resource = resources.value.find(r => r.Id === cmd1.ResourceId)

        if (resource)
        {
            resource.setPortfolioAllocation(cmd1.PortfolioId, cmd1.Allocation)
        }
    })

    // ======================
    // Formatting helpers (1:1)
    // ======================

    function fmtNum(val: number | null) { return toStringSmartly(val) }
    function fmtPct(val: number | null, decimalPlaces: number = 1) { return toPercentageString(val, decimalPlaces) }

    // ======================
    // UI actions (1:1)
    // ======================

    function showSelectorDialog(p: PortfolioSummaryReadModel)
    {
        selectorDialog.show(p.WorkspaceId, p.PortfolioId, p.ScenarioId)
    }

    function showTotalCostLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        totalCostLimitEditorDialog.id = p.Id
        totalCostLimitEditorDialog.value = p.Limit

        totalCostLimitEditorDialog.title = p.Name
        totalCostLimitEditorDialog.label = `Total cost limit (${rm.value?.CurrencyLabel}):`

        totalCostLimitEditorDialog.showValueRange = false
        totalCostLimitEditorDialog.minValue = 0
        totalCostLimitEditorDialog.show()
    }

    function showOpexLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        opexLimitEditorDialog.id = p.Id
        opexLimitEditorDialog.value = p.Limit

        opexLimitEditorDialog.title = p.Name
        opexLimitEditorDialog.label = `Opex limit (${rm.value?.CurrencyLabel}):`

        opexLimitEditorDialog.showValueRange = false
        opexLimitEditorDialog.minValue = 0
        opexLimitEditorDialog.show()
    }

    function showOthexLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        othexLimitEditorDialog.id = p.Id
        othexLimitEditorDialog.value = p.Limit

        othexLimitEditorDialog.title = p.Name
        othexLimitEditorDialog.label = `Other expenses limit (${rm.value?.CurrencyLabel}):`

        othexLimitEditorDialog.showValueRange = false
        othexLimitEditorDialog.minValue = 0
        othexLimitEditorDialog.show()
    }

    function showExpensesLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        expensesLimitEditorDialog.id = p.Id
        expensesLimitEditorDialog.value = p.Limit

        expensesLimitEditorDialog.title = p.Name
        expensesLimitEditorDialog.label = `Expenses limit (${rm.value?.CurrencyLabel}):`

        expensesLimitEditorDialog.showValueRange = false
        expensesLimitEditorDialog.minValue = 0
        expensesLimitEditorDialog.show()
    }

    function showOpexExpensesLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        opexExpensesLimitEditorDialog.id = p.Id
        opexExpensesLimitEditorDialog.value = p.Limit

        opexExpensesLimitEditorDialog.title = p.Name
        opexExpensesLimitEditorDialog.label = `Opex expenses limit (${rm.value?.CurrencyLabel}):`

        opexExpensesLimitEditorDialog.showValueRange = false
        opexExpensesLimitEditorDialog.minValue = 0
        opexExpensesLimitEditorDialog.show()
    }

    function showCapexLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        capexLimitEditorDialog.id = p.Id
        capexLimitEditorDialog.value = p.Limit

        capexLimitEditorDialog.title = p.Name
        capexLimitEditorDialog.label = `Capex limit (${rm.value?.CurrencyLabel}):`

        capexLimitEditorDialog.showValueRange = false
        capexLimitEditorDialog.minValue = 0
        capexLimitEditorDialog.show()
    }

    function showPortfolioResourceAllocationEditorDialog(p: PortfolioResourceAllocationViewModel)
    {
        portfolioResourceAllocationEditorDialog.id = p.Id
        portfolioResourceAllocationEditorDialog.value = p.TargetPercent != null ? 100 * p.TargetPercent : null

        portfolioResourceAllocationEditorDialog.title = p.Name
        portfolioResourceAllocationEditorDialog.label = `Target allocation (%):`

        portfolioResourceAllocationEditorDialog.showValueRange = true
        portfolioResourceAllocationEditorDialog.minValue = 0
        portfolioResourceAllocationEditorDialog.maxValue = 200
        portfolioResourceAllocationEditorDialog.step = 1
        portfolioResourceAllocationEditorDialog.opener = p
        portfolioResourceAllocationEditorDialog.show()
    }

    // ======================
    // Template event handlers (RESTORED 1:1)
    // ======================

    function handlePortfolioResourceAllocationEditorUpdate(value: string | null)
    {
        const allocation = parseOptionalNumber(value)
        const p = portfolioResourceAllocationEditorDialog.opener as PortfolioResourceAllocationViewModel

        invokeSetPortfolioResourceAllocationCommandV1({
            PortfolioId: p.Id,
            ResourceId: p.root.Id,
            Allocation: allocation != null ? allocation / 100 : null
        })

        portfolioResourceAllocationEditorDialog.close()
    }

    function handleUpdateActivePortfolioScenarioCommand(portfolioId: string, portfolioScenarioId: string)
    {
        invokeUpdateActivePortfolioScenarioCommandV1({
            PortfolioId: portfolioId,
            PortfolioScenarioId: portfolioScenarioId
        })
    }

    function handleSetPortfolioTotalCostLimitCommand(value: string | null, portfolioId: string): void
    {
        const limit = parseOptionalNumber(value)

        invokeSetPortfolioTotalCostLimitCommandV1({
            PortfolioId: portfolioId,
            Limit: limit
        })

        budget.value?.updateTotalCostLimit(portfolioId, limit)
        totalCostLimitEditorDialog.close()
    }

    function handleSetPortfolioCapexLimitCommand(value: string | null, portfolioId: string): void
    {
        const limit = parseOptionalNumber(value)

        invokeSetPortfolioCapexLimitCommandV1({
            PortfolioId: portfolioId,
            Limit: limit
        })

        budget.value?.updateCapexLimit(portfolioId, limit)
        capexLimitEditorDialog.close()
    }

    function handleSetPortfolioOpexLimitCommand(value: string | null, portfolioId: string)
    {
        const limit = parseOptionalNumber(value)

        invokeSetPortfolioOpexLimitCommandV1({
            PortfolioId: portfolioId,
            Limit: limit
        })

        budget.value?.updateOpexLimit(portfolioId, limit)
        opexLimitEditorDialog.close()
    }

    function handleSetPortfolioOthexLimitCommand(value: string | null, portfolioId: string)
    {
        const limit = parseOptionalNumber(value)

        invokeSetPortfolioOthexLimitCommandV1({
            PortfolioId: portfolioId,
            Limit: limit
        })

        budget.value?.updateOthexLimit(portfolioId, limit)
        othexLimitEditorDialog.close()
    }

    function handleSetPortfolioExpensesLimitCommand(value: string | null, portfolioId: string)
    {
        const limit = parseOptionalNumber(value)

        invokeSetPortfolioExpensesLimitCommandV1({
            PortfolioId: portfolioId,
            Limit: limit
        })

        budget.value?.updateExpensesLimit(portfolioId, limit)
        expensesLimitEditorDialog.close()
    }

    function handleSetPortfolioOpexExpensesLimitCommand(value: string | null, portfolioId: string)
    {
        const limit = parseOptionalNumber(value)

        invokeSetPortfolioOpexExpensesLimitCommandV1({
            PortfolioId: portfolioId,
            Limit: limit
        })

        budget.value?.updateOpexExpensesLimit(portfolioId, limit)
        opexExpensesLimitEditorDialog.close()
    }

    function onSelected(_result: any)
    {
        runPortfoliosPageQueryV1()
    }

    function onScheduled(_result: any)
    {
        runPortfoliosPageQueryV1()
    }

    // ======================
    // Lifecycle (1:1)
    // ======================

    onMounted(() =>
    {
        document.title = "Enterprise Plan - Portfolios"
        runPortfoliosPageQueryV1()
    })

    // ======================
    // ViewModel classes (UNCHANGED)
    // ======================

    class ResourceAllocationSummaryViewModel
    {
        Id: string
        Name: string
        Unit: string
        IsCollapsed: boolean
        CapacityValue: number
        Portfolios: PortfolioResourceAllocationViewModel[]

        get TargetPercent(): number | null { return sumOrDefault(this.Portfolios.map(a => a.TargetPercent)) }
        get TargetValue(): number | null { return sumOrDefault(this.Portfolios.map(a => a.TargetValue)) }
        get CurrentPercent(): number | null { return calculateProportionOf(this.CurrentValue, this.TargetValue) }
        get CurrentValue(): number | null { return sumOrDefault(this.Portfolios.map(a => a.CurrentValue)) }

        constructor(rm: ResourceAllocationSummaryReadModel)
        {
            this.Id = rm.Id
            this.Name = rm.Name
            this.Unit = rm.Unit
            this.IsCollapsed = rm.IsCollapsed
            this.CapacityValue = rm.CapacityValue
            this.Portfolios = rm.Portfolios.map(p => new PortfolioResourceAllocationViewModel(this, p))
        }

        setPortfolioAllocation(portfolioId: string, allocation: number | null)
        {
            const portfolio = this.Portfolios.find(p => p.Id === portfolioId)
            if (portfolio)
            {
                portfolio.TargetPercent = allocation
            }
        }
    }

    class PortfolioResourceAllocationViewModel
    {
        root: ResourceAllocationSummaryViewModel

        Id: string
        Name: string
        IsLinked: boolean

        TargetPercent: number | null
        CurrentValue: number | null

        constructor(resource: ResourceAllocationSummaryViewModel, rm: PortfolioResourceAllocationReadModel)
        {
            this.root = resource

            this.Id = rm.Id
            this.Name = rm.Name
            this.IsLinked = rm.IsLinked
            this.TargetPercent = rm.TargetPercent
            this.CurrentValue = rm.CurrentValue
        }

        get TargetValue(): number | null
        {
            return this.TargetPercent === null ? null : this.TargetPercent * this.root.CapacityValue
        }

        get CurrentPercent(): number | null { return calculateProportionOf(this.CurrentValue, this.TargetValue) }
    }

    class BudgetAllocationSummaryViewModel
    {
        TotalCostItems: PortfolioBudgetAllocationViewModel[]
        CapexItems: PortfolioBudgetAllocationViewModel[]
        OpexItems: PortfolioBudgetAllocationViewModel[]
        OthexItems: PortfolioBudgetAllocationViewModel[]
        ExpensesItems: PortfolioBudgetAllocationViewModel[]
        OpexExpensesItems: PortfolioBudgetAllocationViewModel[]

        TotalCostCollapsed: boolean = true
        CapexCollapsed: boolean = true
        OpexCollapsed: boolean = true
        OthexCollapsed: boolean = true
        ExpensesCollapsed: boolean = true
        OpexExpensesCollapsed: boolean = true

        get TotalCostLimit(): number | null { return sumOrDefault(this.TotalCostItems.map(a => a.Limit)) }
        get TotalCostCurrentValue(): number | null { return sumOrDefault(this.TotalCostItems.map(a => a.CurrentValue)) }
        get CapexLimit(): number | null { return sumOrDefault(this.CapexItems.map(a => a.Limit)) }
        get CapexCurrentValue(): number | null { return sumOrDefault(this.CapexItems.map(a => a.CurrentValue)) }
        get OpexLimit(): number | null { return sumOrDefault(this.OpexItems.map(a => a.Limit)) }
        get OpexCurrentValue(): number | null { return sumOrDefault(this.OpexItems.map(a => a.CurrentValue)) }
        get OthexLimit(): number | null { return sumOrDefault(this.OthexItems.map(a => a.Limit)) }
        get OthexCurrentValue(): number | null { return sumOrDefault(this.OthexItems.map(a => a.CurrentValue)) }
        get ExpensesLimit(): number | null { return sumOrDefault(this.ExpensesItems.map(a => a.Limit)) }
        get ExpensesCurrentValue(): number | null { return sumOrDefault(this.ExpensesItems.map(a => a.CurrentValue)) }
        get OpexExpensesLimit(): number | null { return sumOrDefault(this.OpexExpensesItems.map(a => a.Limit)) }
        get OpexExpensesCurrentValue(): number | null { return sumOrDefault(this.OpexExpensesItems.map(a => a.CurrentValue)) }

        constructor(rm: BudgetAllocationSummaryReadModel)
        {
            this.TotalCostItems = rm.TotalCost.map(a => new PortfolioBudgetAllocationViewModel(this, a))
            this.CapexItems = rm.Capex.map(a => new PortfolioBudgetAllocationViewModel(this, a))
            this.OpexItems = rm.Opex.map(a => new PortfolioBudgetAllocationViewModel(this, a))
            this.OthexItems = rm.Othex.map(a => new PortfolioBudgetAllocationViewModel(this, a))
            this.ExpensesItems = rm.Expenses.map(a => new PortfolioBudgetAllocationViewModel(this, a))
            this.OpexExpensesItems = rm.OpexExpenses.map(a => new PortfolioBudgetAllocationViewModel(this, a))
        }

        updateTotalCostLimit(portfolioId: string, value: number | null)
        {
            const item = this.TotalCostItems.find(p => p.Id === portfolioId)
            if (item) item.Limit = value
        }

        updateOpexLimit(portfolioId: string, value: number | null)
        {
            const item = this.OpexItems.find(p => p.Id === portfolioId)
            if (item) item.Limit = value
        }

        updateOthexLimit(portfolioId: string, value: number | null)
        {
            const item = this.OthexItems.find(p => p.Id === portfolioId)
            if (item) item.Limit = value
        }

        updateExpensesLimit(portfolioId: string, value: number | null)
        {
            const item = this.ExpensesItems.find(p => p.Id === portfolioId)
            if (item) item.Limit = value
        }

        updateOpexExpensesLimit(portfolioId: string, value: number | null)
        {
            const item = this.OpexExpensesItems.find(p => p.Id === portfolioId)
            if (item) item.Limit = value
        }

        updateCapexLimit(portfolioId: string, value: number | null)
        {
            const item = this.CapexItems.find(p => p.Id === portfolioId)
            if (item) item.Limit = value
        }
    }

    class PortfolioBudgetAllocationViewModel
    {
        root: BudgetAllocationSummaryViewModel

        Id: string
        Name: string
        Limit: number | null
        CurrentValue: number | null

        constructor(root: BudgetAllocationSummaryViewModel, rm: PortfolioBudgetAllocationReadModel)
        {
            this.root = root

            this.Id = rm.Id
            this.Name = rm.Name
            this.Limit = rm.Limit
            this.CurrentValue = rm.CurrentValue
        }
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SelectorDialog, {
      viewModel: _unref(selectorDialog),
      onSelected: onSelected
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(NumericInputDialog, {
      viewModel: _unref(totalCostLimitEditorDialog),
      onUpdateValue: handleSetPortfolioTotalCostLimitCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(NumericInputDialog, {
      viewModel: _unref(opexLimitEditorDialog),
      onUpdateValue: handleSetPortfolioOpexLimitCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(NumericInputDialog, {
      viewModel: _unref(othexLimitEditorDialog),
      onUpdateValue: handleSetPortfolioOthexLimitCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(NumericInputDialog, {
      viewModel: _unref(capexLimitEditorDialog),
      onUpdateValue: handleSetPortfolioCapexLimitCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(NumericInputDialog, {
      viewModel: _unref(expensesLimitEditorDialog),
      onUpdateValue: handleSetPortfolioExpensesLimitCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(NumericInputDialog, {
      viewModel: _unref(opexExpensesLimitEditorDialog),
      onUpdateValue: handleSetPortfolioOpexExpensesLimitCommand
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(NumericInputDialog, {
      viewModel: _unref(portfolioResourceAllocationEditorDialog),
      onUpdateValue: handlePortfolioResourceAllocationEditorUpdate
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(CorporateNavigation, { ActivePage: "dashboard" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, "Enterprise Plan: " + _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */),
              _cache[6] || (_cache[6] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Portfolios", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(ScenarioNavigation, { onScheduled: onScheduled })
            ])
          ]),
          _cache[56] || (_cache[56] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", _hoisted_8, [
                _createElementVNode("tr", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("th", {
                    colspan: "2",
                    class: "align-middle"
                  }, "Portfolio", -1 /* CACHED */)),
                  _cache[14] || (_cache[14] = _createElementVNode("th", { class: "align-middle text-center" }, "Requested projects", -1 /* CACHED */)),
                  _cache[15] || (_cache[15] = _createElementVNode("th", { class: "align-middle text-center" }, "Selected projects", -1 /* CACHED */)),
                  _cache[16] || (_cache[16] = _createElementVNode("th", { class: "align-middle text-center" }, "Value points", -1 /* CACHED */)),
                  _createElementVNode("th", _hoisted_9, [
                    _cache[7] || (_cache[7] = _createTextVNode("Revenue ", -1 /* CACHED */)),
                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createTextVNode(" (" + _toDisplayString(_unref(rm).CurrencyLabel) + ")", 1 /* TEXT */)
                  ]),
                  _createElementVNode("th", {
                    class: "align-middle text-center",
                    title: _unref(rm).TotalCostLabel
                  }, [
                    _cache[9] || (_cache[9] = _createTextVNode("Cost ", -1 /* CACHED */)),
                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createTextVNode(" (" + _toDisplayString(_unref(rm).CurrencyLabel) + ")", 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_10),
                  _createElementVNode("th", _hoisted_11, [
                    _cache[11] || (_cache[11] = _createTextVNode("Cost of value point", -1 /* CACHED */)),
                    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createTextVNode(" (" + _toDisplayString(_unref(rm).CurrencyLabel) + ")", 1 /* TEXT */)
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("th", { class: "align-middle text-center" }, [
                    _createTextVNode("Strategic fit "),
                    _createElementVNode("br"),
                    _createTextVNode(" (0-100)")
                  ], -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Portfolios, (p) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: p.PortfolioId
                  }, [
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(p.PortfolioName), 1 /* TEXT */),
                      _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      (p.ScenarioId)
                        ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_12, [
                            _createTextVNode(_toDisplayString(p.ScenarioName), 1 /* TEXT */)
                          ])), [
                            [_directive_sanitizedHref, `/#/portfolio-plan/projects/${p.WorkspaceId}/${p.TchProjectId}/${p.ScenarioId}`]
                          ])
                        : _createCommentVNode("v-if", true),
                      (!p.ScenarioId)
                        ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_13, [...(_cache[18] || (_cache[18] = [
                            _createTextVNode(" No portfolio plan ", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, `/#/portfolio/plans/${p.WorkspaceId}/${p.TchProjectId}`]
                          ])
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[23] || (_cache[23] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary",
                          "data-toggle": "dropdown"
                        }, [
                          _createElementVNode("i", { class: "fa-solid fa-ellipsis" })
                        ], -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_16, [
                          _cache[21] || (_cache[21] = _createElementVNode("h6", { class: "dropdown-header" }, "Portfolio plans", -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Scenarios, (s) => {
                            return (_openBlock(), _createElementBlock("a", {
                              class: "dropdown-item",
                              key: s.Id,
                              onClick: ($event: any) => (handleUpdateActivePortfolioScenarioCommand(p.PortfolioId, s.Id))
                            }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_17))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_18, [...(_cache[20] || (_cache[20] = [
                            _createTextVNode("Manage plans", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, `/#/portfolio/plans/${p.WorkspaceId}/${p.TchProjectId}`]
                          ])
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-success",
                        onClick: ($event: any) => (showSelectorDialog(p)),
                        disabled: p.ScenarioId == null,
                        title: "Selector"
                      }, [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("i", { class: "fa-solid fa-robot" }, null, -1 /* CACHED */)
                      ]))], 8 /* PROPS */, _hoisted_19)
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createTextVNode(_toDisplayString(p.RequestedProjectsCount), 1 /* TEXT */),
                      _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_21, _toDisplayString(fmtPct(p.RequestedProjectsCountShare)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      _createTextVNode(_toDisplayString(p.AcceptedProjectsCount), 1 /* TEXT */),
                      _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_23, _toDisplayString(fmtPct(p.AcceptedProjectsCountShare)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      _createTextVNode(_toDisplayString(fmtNum(p.PlannedValuePoints)), 1 /* TEXT */),
                      _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_25, _toDisplayString(fmtPct(p.PlannedValuePointsShare)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createTextVNode(_toDisplayString(fmtNum(p.PlannedRevenue)), 1 /* TEXT */),
                      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_27, _toDisplayString(fmtPct(p.PlannedRevenueShare)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_28, [
                      _createTextVNode(_toDisplayString(fmtNum(p.PlannedCost)), 1 /* TEXT */),
                      _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_29, _toDisplayString(fmtPct(p.PlannedCostShare)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(fmtNum(p.CostOfValuePoint)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(fmtNum(p.StrategicFit, 10)), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("tfoot", _hoisted_32, [
                _createElementVNode("tr", null, [
                  _cache[30] || (_cache[30] = _createElementVNode("td", { colspan: "2" }, null, -1 /* CACHED */)),
                  _createElementVNode("th", _hoisted_33, _toDisplayString(_unref(rm).RequestedProjectsCount), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_34, _toDisplayString(_unref(rm).AcceptedProjectsCount), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_35, _toDisplayString(fmtNum(_unref(rm).PlannedValuePoints)), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_36, _toDisplayString(fmtNum(_unref(rm).PlannedRevenue)), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_37, _toDisplayString(fmtNum(_unref(rm).PlannedCost)), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_38, _toDisplayString(fmtNum(_unref(rm).CostOfValuePoint)), 1 /* TEXT */),
                  _cache[31] || (_cache[31] = _createElementVNode("td", { class: "text-center" }, null, -1 /* CACHED */))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("table", _hoisted_40, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_41, [
                  _cache[36] || (_cache[36] = _createElementVNode("th", {
                    colspan: "2",
                    class: "align-middle"
                  }, "Budget allocation", -1 /* CACHED */)),
                  _createElementVNode("th", _hoisted_42, [
                    _cache[32] || (_cache[32] = _createTextVNode("Allocation ", -1 /* CACHED */)),
                    _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createTextVNode(" (" + _toDisplayString(_unref(rm).CurrencyLabel) + ")", 1 /* TEXT */)
                  ]),
                  _createElementVNode("th", _hoisted_43, [
                    _cache[34] || (_cache[34] = _createTextVNode("Limit", -1 /* CACHED */)),
                    _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createTextVNode(" (" + _toDisplayString(_unref(rm).CurrencyLabel) + ")", 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("tbody", _hoisted_44, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_45, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (budget.value.TotalCostCollapsed = !budget.value.TotalCostCollapsed))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['fa', budget.value.TotalCostCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'])
                      }, null, 2 /* CLASS */)
                    ])
                  ]),
                  _createElementVNode("th", null, [
                    _cache[37] || (_cache[37] = _createTextVNode(" Total cost", -1 /* CACHED */)),
                    _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createElementVNode("small", _hoisted_46, _toDisplayString(_unref(rm).TotalCostLabel), 1 /* TEXT */)
                  ]),
                  _createElementVNode("th", _hoisted_47, _toDisplayString(fmtNum(budget.value.TotalCostCurrentValue)), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_48, _toDisplayString(fmtNum(budget.value.TotalCostLimit)), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(budget.value.TotalCostItems, (p) => {
                  return _withDirectives((_openBlock(), _createElementBlock("tr", {
                    key: p.Id
                  }, [
                    _cache[39] || (_cache[39] = _createElementVNode("td", null, null, -1 /* CACHED */)),
                    _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_49, _toDisplayString(fmtNum(p.CurrentValue)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_50, [
                      (p.Limit != null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "text-primary",
                            onClick: ($event: any) => (showTotalCostLimitEditor(p))
                          }, _toDisplayString(fmtNum(p.Limit)), 9 /* TEXT, PROPS */, _hoisted_51))
                        : _createCommentVNode("v-if", true),
                      (p.Limit == null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "text-danger font-italic pointer",
                            onClick: ($event: any) => (showTotalCostLimitEditor(p))
                          }, "Not set", 8 /* PROPS */, _hoisted_52))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])), [
                    [_vShow, budget.value.TotalCostCollapsed === false]
                  ])
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("tbody", _hoisted_53, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_54, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (budget.value.OpexCollapsed = !budget.value.OpexCollapsed))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['fa', budget.value.OpexCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'])
                      }, null, 2 /* CLASS */)
                    ])
                  ]),
                  _cache[40] || (_cache[40] = _createElementVNode("th", null, " Opex ", -1 /* CACHED */)),
                  _createElementVNode("th", _hoisted_55, _toDisplayString(fmtNum(budget.value.OpexCurrentValue)), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_56, _toDisplayString(fmtNum(budget.value.OpexLimit)), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(budget.value.OpexItems, (p) => {
                  return _withDirectives((_openBlock(), _createElementBlock("tr", {
                    key: p.Id
                  }, [
                    _cache[41] || (_cache[41] = _createElementVNode("td", null, null, -1 /* CACHED */)),
                    _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_57, _toDisplayString(fmtNum(p.CurrentValue)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_58, [
                      (p.Limit != null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "text-primary",
                            onClick: ($event: any) => (showOpexLimitEditor(p))
                          }, _toDisplayString(fmtNum(p.Limit)), 9 /* TEXT, PROPS */, _hoisted_59))
                        : _createCommentVNode("v-if", true),
                      (p.Limit == null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "text-danger font-italic pointer",
                            onClick: ($event: any) => (showOpexLimitEditor(p))
                          }, "Not set", 8 /* PROPS */, _hoisted_60))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])), [
                    [_vShow, budget.value.OpexCollapsed === false]
                  ])
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("tbody", _hoisted_61, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_62, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (budget.value.CapexCollapsed = !budget.value.CapexCollapsed))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['fa', budget.value.CapexCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'])
                      }, null, 2 /* CLASS */)
                    ])
                  ]),
                  _cache[42] || (_cache[42] = _createElementVNode("th", null, " Capex ", -1 /* CACHED */)),
                  _createElementVNode("th", _hoisted_63, _toDisplayString(fmtNum(budget.value.CapexCurrentValue)), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_64, _toDisplayString(fmtNum(budget.value.CapexLimit)), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(budget.value.CapexItems, (p) => {
                  return _withDirectives((_openBlock(), _createElementBlock("tr", {
                    key: p.Id
                  }, [
                    _cache[43] || (_cache[43] = _createElementVNode("td", null, null, -1 /* CACHED */)),
                    _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_65, _toDisplayString(fmtNum(p.CurrentValue)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_66, [
                      (p.Limit != null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "text-primary",
                            onClick: ($event: any) => (showCapexLimitEditor(p))
                          }, _toDisplayString(fmtNum(p.Limit)), 9 /* TEXT, PROPS */, _hoisted_67))
                        : _createCommentVNode("v-if", true),
                      (p.Limit == null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "text-danger font-italic pointer",
                            onClick: ($event: any) => (showCapexLimitEditor(p))
                          }, "Not set", 8 /* PROPS */, _hoisted_68))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])), [
                    [_vShow, budget.value.CapexCollapsed === false]
                  ])
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("tbody", _hoisted_69, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_70, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (budget.value.OthexCollapsed = !budget.value.OthexCollapsed))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['fa', budget.value.OthexCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'])
                      }, null, 2 /* CLASS */)
                    ])
                  ]),
                  _cache[44] || (_cache[44] = _createElementVNode("th", null, [
                    _createTextVNode(" Other"),
                    _createElementVNode("br"),
                    _createElementVNode("small", { class: "text-muted" }, "Non-Opex, Non-COGS")
                  ], -1 /* CACHED */)),
                  _createElementVNode("th", _hoisted_71, _toDisplayString(fmtNum(budget.value.OthexCurrentValue)), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_72, _toDisplayString(fmtNum(budget.value.OthexLimit)), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(budget.value.OthexItems, (p) => {
                  return _withDirectives((_openBlock(), _createElementBlock("tr", {
                    key: p.Id
                  }, [
                    _cache[45] || (_cache[45] = _createElementVNode("td", null, null, -1 /* CACHED */)),
                    _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_73, _toDisplayString(fmtNum(p.CurrentValue)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_74, [
                      (p.Limit != null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "text-primary",
                            onClick: ($event: any) => (showOthexLimitEditor(p))
                          }, _toDisplayString(fmtNum(p.Limit)), 9 /* TEXT, PROPS */, _hoisted_75))
                        : _createCommentVNode("v-if", true),
                      (p.Limit == null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "text-danger font-italic pointer",
                            onClick: ($event: any) => (showOthexLimitEditor(p))
                          }, "Not set", 8 /* PROPS */, _hoisted_76))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])), [
                    [_vShow, budget.value.OthexCollapsed === false]
                  ])
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("tbody", _hoisted_77, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_78, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (budget.value.ExpensesCollapsed = !budget.value.ExpensesCollapsed))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['fa', budget.value.ExpensesCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'])
                      }, null, 2 /* CLASS */)
                    ])
                  ]),
                  _cache[46] || (_cache[46] = _createElementVNode("th", null, [
                    _createTextVNode(" Expenses (All)"),
                    _createElementVNode("br"),
                    _createElementVNode("small", { class: "text-muted" }, "Cogs, Opex, Other")
                  ], -1 /* CACHED */)),
                  _createElementVNode("th", _hoisted_79, _toDisplayString(fmtNum(budget.value.ExpensesCurrentValue)), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_80, _toDisplayString(fmtNum(budget.value.ExpensesLimit)), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(budget.value.ExpensesItems, (p) => {
                  return _withDirectives((_openBlock(), _createElementBlock("tr", {
                    key: p.Id
                  }, [
                    _cache[47] || (_cache[47] = _createElementVNode("td", null, null, -1 /* CACHED */)),
                    _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_81, _toDisplayString(fmtNum(p.CurrentValue)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_82, [
                      (p.Limit != null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "text-primary",
                            onClick: ($event: any) => (showExpensesLimitEditor(p))
                          }, _toDisplayString(fmtNum(p.Limit)), 9 /* TEXT, PROPS */, _hoisted_83))
                        : _createCommentVNode("v-if", true),
                      (p.Limit == null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "text-danger font-italic pointer",
                            onClick: ($event: any) => (showExpensesLimitEditor(p))
                          }, "Not set", 8 /* PROPS */, _hoisted_84))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])), [
                    [_vShow, budget.value.ExpensesCollapsed === false]
                  ])
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("tbody", _hoisted_85, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_86, [
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (budget.value.OpexExpensesCollapsed = !budget.value.OpexExpensesCollapsed))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['fa', budget.value.OpexExpensesCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'])
                      }, null, 2 /* CLASS */)
                    ])
                  ]),
                  _cache[48] || (_cache[48] = _createElementVNode("th", null, [
                    _createTextVNode(" Expenses (Opex)"),
                    _createElementVNode("br"),
                    _createElementVNode("small", { class: "text-muted" }, "Opex Expense Accounts")
                  ], -1 /* CACHED */)),
                  _createElementVNode("th", _hoisted_87, _toDisplayString(fmtNum(budget.value.OpexExpensesCurrentValue)), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_88, _toDisplayString(fmtNum(budget.value.OpexExpensesLimit)), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(budget.value.OpexExpensesItems, (p) => {
                  return _withDirectives((_openBlock(), _createElementBlock("tr", {
                    key: p.Id
                  }, [
                    _cache[49] || (_cache[49] = _createElementVNode("td", null, null, -1 /* CACHED */)),
                    _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_89, _toDisplayString(fmtNum(p.CurrentValue)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_90, [
                      (p.Limit != null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "text-primary",
                            onClick: ($event: any) => (showOpexExpensesLimitEditor(p))
                          }, _toDisplayString(fmtNum(p.Limit)), 9 /* TEXT, PROPS */, _hoisted_91))
                        : _createCommentVNode("v-if", true),
                      (p.Limit == null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "text-danger font-italic pointer",
                            onClick: ($event: any) => (showOpexExpensesLimitEditor(p))
                          }, "Not set", 8 /* PROPS */, _hoisted_92))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])), [
                    [_vShow, budget.value.OpexExpensesCollapsed === false]
                  ])
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("table", _hoisted_94, [
              _cache[53] || (_cache[53] = _createElementVNode("thead", null, [
                _createElementVNode("tr", { class: "table-secondary" }, [
                  _createElementVNode("th", {
                    colspan: "2",
                    class: "align-middle"
                  }, "Resource allocation"),
                  _createElementVNode("th", { class: "align-middle text-center" }, [
                    _createTextVNode(" Target "),
                    _createElementVNode("br"),
                    _createElementVNode("small", { class: "text-muted" }, "% of available")
                  ]),
                  _createElementVNode("th", { class: "align-middle text-center" }, [
                    _createTextVNode(" Capacity "),
                    _createElementVNode("br"),
                    _createElementVNode("small", { class: "text-muted" }, "Target based")
                  ]),
                  _createElementVNode("th", { class: "align-middle text-center" }, "Allocation")
                ])
              ], -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resources.value, (r) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  key: r.Id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_95, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-secondary",
                        onClick: ($event: any) => (r.IsCollapsed = !r.IsCollapsed)
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(['fa', r.IsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'])
                        }, null, 2 /* CLASS */)
                      ], 8 /* PROPS */, _hoisted_96)
                    ]),
                    _createElementVNode("th", null, _toDisplayString(r.Name), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_97, [
                      _createElementVNode("span", {
                        class: _normalizeClass([r.TargetPercent > 1  ? 'text-danger' : 'text-dark'])
                      }, _toDisplayString(fmtPct(r.TargetPercent, 0)), 3 /* TEXT, CLASS */)
                    ]),
                    _createElementVNode("th", _hoisted_98, [
                      (r.TargetValue != null)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass([r.TargetPercent > 1  ? 'text-danger' : 'text-dark'])
                          }, _toDisplayString(fmtNum(r.TargetValue)) + " " + _toDisplayString(r.Unit), 3 /* TEXT, CLASS */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("th", _hoisted_99, [
                      _createTextVNode(_toDisplayString(fmtNum(r.CurrentValue)) + " " + _toDisplayString(r.Unit) + " ", 1 /* TEXT */),
                      _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", _hoisted_100, _toDisplayString(fmtPct(r.CurrentPercent)), 1 /* TEXT */)
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.Portfolios, (p) => {
                    return _withDirectives((_openBlock(), _createElementBlock("tr", {
                      key: p.Id
                    }, [
                      _cache[52] || (_cache[52] = _createElementVNode("td", null, null, -1 /* CACHED */)),
                      _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_101, [
                        (p.IsLinked === true)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (p.TargetPercent != null)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "text-primary",
                                    onClick: ($event: any) => (showPortfolioResourceAllocationEditorDialog(p))
                                  }, _toDisplayString(fmtPct(p.TargetPercent, 0)), 9 /* TEXT, PROPS */, _hoisted_102))
                                : _createCommentVNode("v-if", true),
                              (p.TargetPercent == null)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "text-muted font-italic pointer",
                                    onClick: ($event: any) => (showPortfolioResourceAllocationEditorDialog(p))
                                  }, "Not set", 8 /* PROPS */, _hoisted_103))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("td", _hoisted_104, [
                        (p.IsLinked === true && p.TargetValue != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(fmtNum(p.TargetValue)) + " " + _toDisplayString(r.Unit), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("td", _hoisted_105, [
                        _createTextVNode(_toDisplayString(fmtNum(p.CurrentValue)), 1 /* TEXT */),
                        _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", _hoisted_106, _toDisplayString(fmtPct(p.CurrentPercent)), 1 /* TEXT */)
                      ])
                    ])), [
                      [_vShow, r.IsCollapsed == false]
                    ])
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("table", _hoisted_108, [
              _cache[55] || (_cache[55] = _createElementVNode("thead", null, [
                _createElementVNode("tr", { class: "table-secondary" }, [
                  _createElementVNode("th", null, "Capacity minus allocated"),
                  _createElementVNode("th", { class: "text-center" }, "Jan"),
                  _createElementVNode("th", { class: "text-center" }, "Feb"),
                  _createElementVNode("th", { class: "text-center" }, "Mar"),
                  _createElementVNode("th", { class: "text-center" }, "Apr"),
                  _createElementVNode("th", { class: "text-center" }, "May"),
                  _createElementVNode("th", { class: "text-center" }, "Jun"),
                  _createElementVNode("th", { class: "text-center" }, "Jul"),
                  _createElementVNode("th", { class: "text-center" }, "Aug"),
                  _createElementVNode("th", { class: "text-center" }, "Sep"),
                  _createElementVNode("th", { class: "text-center" }, "Oct"),
                  _createElementVNode("th", { class: "text-center" }, "Nov"),
                  _createElementVNode("th", { class: "text-center" }, "Dec")
                ])
              ], -1 /* CACHED */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Usage, (r) => {
                return (_openBlock(), _createElementBlock("tbody", {
                  key: r.Id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_109, [
                        _createTextVNode(_toDisplayString(r.Name) + " " + _toDisplayString(r.Unit), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, `/#/enterprise/resource-capacity/${workspaceId.value}/${strategyId.value}/${r.Id}`]
                      ])
                    ]),
                    _cache[54] || (_cache[54] = _createElementVNode("td", { colspan: "12" }, null, -1 /* CACHED */))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.Years, (y) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: y.Year
                    }, [
                      _createElementVNode("td", _hoisted_110, _toDisplayString(y.Year), 1 /* TEXT */),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                        return _createElementVNode("td", {
                          class: _normalizeClass(["align-middle text-center", {'table-danger': y.Capacity[i-1] - y.Allocation[i-1] < 0}]),
                          key: i
                        }, _toDisplayString(fmtNum(y.Capacity[i-1] - y.Allocation[i-1])), 3 /* TEXT, CLASS */)
                      }), 64 /* STABLE_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})